class RecentSearches extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'wokiee:recent-searches';
    this.maxItems = 5;
  }

  connectedCallback() {
    this.render();

    document.addEventListener('submit', this.handleSubmit.bind(this), true);

    const modal = this.closest('.popup-modal');
    if (modal) {
      this.modalObserver = new MutationObserver(() => {
        if (modal.classList.contains('active')) this.render();
      });
      this.modalObserver.observe(modal, { attributes: true, attributeFilter: ['class'] });
    }
  }

  disconnectedCallback() {
    if (this.modalObserver) this.modalObserver.disconnect();
  }

  getStored() {
    try {
      const raw = localStorage.getItem(this.storageKey);
      const list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  handleSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.getAttribute('role') !== 'search') return;

    const input = form.querySelector('input[name="q"]');
    const query = input && input.value.trim();
    if (!query) return;

    let list = this.getStored().filter((term) => term.toLowerCase() !== query.toLowerCase());
    list.unshift(query);
    list = list.slice(0, this.maxItems);

    try {
      localStorage.setItem(this.storageKey, JSON.stringify(list));
    } catch (error) {
      // localStorage unavailable (privacy mode, etc.) - ignore
    }
  }

  render() {
    const listContainer = this.querySelector('.recent-searches__list');
    if (!listContainer) return;

    const list = this.getStored();

    if (list.length === 0) {
      this.classList.add('hide');
      listContainer.innerHTML = '';
      return;
    }

    this.classList.remove('hide');
    listContainer.innerHTML = list
      .map(
        (term) => `
        <a href="${this.searchUrl(term)}" class="recent-searches__pill">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 26 26" fill="none">
            <mask id="mask0_1416_544" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="26" height="26">
              <rect width="25.4" height="25.4" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_1416_544)">
              <path d="M12.6998 22.2258C10.2656 22.2258 8.14456 21.4188 6.33658 19.8048C4.52859 18.1909 3.4923 16.1756 3.22772 13.7591H5.3973C5.64425 15.5936 6.46005 17.1105 7.8447 18.3099C9.22935 19.5094 10.8477 20.1091 12.6998 20.1091C14.7636 20.1091 16.5142 19.3903 17.9518 17.9528C19.3894 16.5152 20.1081 14.7645 20.1081 12.7008C20.1081 10.637 19.3894 8.88637 17.9518 7.4488C16.5142 6.01123 14.7636 5.29245 12.6998 5.29245C11.4827 5.29245 10.345 5.57467 9.28668 6.13911C8.22835 6.70356 7.33758 7.47967 6.61439 8.46745H9.5248V10.5841H3.1748V4.23411H5.29147V6.7212C6.19105 5.59231 7.28908 4.71918 8.58553 4.10182C9.88199 3.48446 11.2534 3.17578 12.6998 3.17578C14.0227 3.17578 15.2619 3.42714 16.4172 3.92984C17.5725 4.43255 18.578 5.11165 19.4335 5.96714C20.2889 6.82262 20.968 7.82804 21.4707 8.98339C21.9734 10.1387 22.2248 11.3779 22.2248 12.7008C22.2248 14.0237 21.9734 15.2628 21.4707 16.4182C20.968 17.5735 20.2889 18.5789 19.4335 19.4344C18.578 20.2899 17.5725 20.969 16.4172 21.4717C15.2619 21.9744 14.0227 22.2258 12.6998 22.2258ZM15.6631 17.1458L11.6415 13.1241V7.40911H13.7581V12.2774L17.1448 15.6641L15.6631 17.1458Z" fill="#1C1B1F"/>
            </g>
          </svg>
          <span>${this.escapeHtml(term)}</span>
        </a>`
      )
      .join('');
  }

  searchUrl(term) {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return `${root.replace(/\/$/, '')}/search?q=${encodeURIComponent(term)}`;
  }

  escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML;
  }
}

if (!customElements.get('recent-searches')) {
  customElements.define('recent-searches', RecentSearches);
}
